import React from "react";
import styles from './MobileFooter.module.sass';
import cn from 'classnames';
import { Link, withRouter } from "react-router-dom";
import Image from "../Image";
import Notification from "../Header/Notification";
import User from "../Header/User";

const MobileFooter = ({className, location}) => {

    const isChat = location.pathname.includes('chat');
    const isHome = location.pathname == '/';

    const homeIcon = isHome ? '/assets/icon_home.png' : '/assets/icon_home_blue.png';
    const chatIcon = isChat ? '/assets/icon_chat.png' : '/assets/icon_chat_blue.png';

    return <nav className={cn(className, styles.footerNav)}>
        <Link className={cn(styles.head)} to={'/'}>
            <Image src={homeIcon} srcDark={homeIcon}/>
        </Link>
        <Notification className={styles.notification} />
        {/* <Link className={cn(styles.head)} to={'/chat'}>
            <Image src={chatIcon} srcDark={chatIcon}/>
        </Link> */}
        <User className={styles.user} />
    </nav>;

};

export default withRouter(MobileFooter);
